/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Oscari_S2Inputs */

const en_tut_oscari_s2 = /** @type {(inputs: Tut_Oscari_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move through results with the arrow keys and press Enter to see the detail.`)
};

const id_tut_oscari_s2 = /** @type {(inputs: Tut_Oscari_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telusuri hasil dengan tombol panah, tekan Enter untuk melihat detailnya.`)
};

/**
* | output |
* | --- |
* | "Move through results with the arrow keys and press Enter to see the detail." |
*
* @param {Tut_Oscari_S2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_oscari_s2 = /** @type {((inputs?: Tut_Oscari_S2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Oscari_S2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_oscari_s2(inputs)
	return en_tut_oscari_s2(inputs)
});